import Login from "../views/login";
import Main from "../views/main";

// 不需要权限控制的路由
const baseRouter = [
  {
    path: "/",
    redirect: "/application",
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/main",
    component: Main,
    redirect: "",
    title: "",
    icon: "",
    children: [
      {
        path: "/application",
        component: () => import("@/views/application/index"),
        name: "application",
        title: "应用列表",
        icon: "",
      },
      {
        path: "/logRecord",
        component: () => import("@/views/logRecord/index"),
        name: "logRecord",
        title: "日志记录",
        icon: "",
      },
    ],
  },
];
export default baseRouter;
